import { observer, inject } from 'mobx-react';
import { TLCode, Page } from '../../common/enums';
import React from 'react';
import withTranslate, { WithTranslateProps } from '../common/WithTranslate';
import { FormComponentProps } from 'antd/lib/form';
import { Form, FormSpy } from 'react-final-form';
import { Intent, Button, Tooltip, Label } from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';
import { PharmacyFormField, PharmacyFormField2 } from '../common/form';
import SimpleTextFormContent from '../common/form/SimpleTextFormGroup';
import { Instance } from 'mobx-state-tree';
import styled from '@emotion/styled';
import DateInputFormField from '../common/form/DateInputFormField';
import { Pharmacy } from '../../store/models/Pharmacy';
import RadioGroupFormField from '../common/form/RadioGroupFormField';
import RadioInput from '../common/input/basicInputs/RadioInput';
import moment from 'moment';
import LeaveRouteDirtyWrapper from '../common/LeaveRouteDirtyWrapper';
import { Link } from 'react-router-dom';
import { TranslatedMessage } from '../common/translation';
import { AuthenticationStore, DutyAssignmentStore, SecretariatStore } from '../../store';
import Select from 'react-select';
import DateInput from '../common/input/DateInput';

const DivColumnExt = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 400px;
`;

interface DutyAssignmentFormProps extends WithTranslateProps, FormComponentProps {
  pharmacyList: Array<Instance<typeof Pharmacy>>;
  save: (data: any) => void;
  cleanGeneratedDuties: () => void;
  searchCriteria: any;
  getDutyAssignmentForSelection: (data: any) => void;
  DutyAssignmentStore?: Instance<typeof DutyAssignmentStore>;
  AuthenticationStore?: Instance<typeof AuthenticationStore>;
  SecretariatStore?: Instance<typeof SecretariatStore>;
}

interface DutyAssignmentFormState {
  data: any;
  date: string | null;
  type: string | null;
  pharmacyId: number | undefined;
  searchCriteria: any;
  hasChanges: boolean;
  selectedPharmacy: any;
}

@inject('DutyAssignmentStore', 'AuthenticationStore', 'SecretariatStore')
@observer
class DutyAssignmentForm extends React.Component<DutyAssignmentFormProps, DutyAssignmentFormState> {
  state = {
    data: {
      date: null,
      type: null,
      pharmacyId: null,
    },
    date: null,
    pharmacyId: undefined,
    type: null,
    searchCriteria: this.props.searchCriteria,
    hasChanges: false,
    selectedPharmacy: null,
  } as DutyAssignmentFormState;

  suggestInput;

  onSelectedPharmacyChanged2 = (event) => {
    this.setState({ selectedPharmacy: event });
  };

  showPharmacy = (pharmacy: any) => {
    return (
      (this.props.AuthenticationStore!.isSuperAdmin && this.props.SecretariatStore!.selectedSecretariatId === 0) ||
      (this.props.AuthenticationStore!.isSuperAdmin &&
        pharmacy !== undefined &&
        this.props.SecretariatStore!.selectedSecretariatId !== undefined &&
        this.props.SecretariatStore!.selectedSecretariatId === pharmacy!.secretariatId) ||
      (pharmacy !== undefined &&
        this.props.AuthenticationStore!.isSecretariat &&
        this.props.AuthenticationStore!.secretariatId === pharmacy!.secretariatId)
    );
  };

  render() {
    const { save, pharmacyList, translate, getDutyAssignmentForSelection, DutyAssignmentStore } = this.props;
    const { hasChanges } = this.state;
    return (
      <Form
        initialValues={this.state.data}
        onSubmit={(data: any) => {
          const date = data.date;
          data.date = moment(data.date).format();
          save(data);
          const date2 = moment(date).add(1, 'd');

          // this.setState({ pharmacyId: undefined });

          this.setState({ data: { date: date2.toDate(), type: data.type, pharmacyId: null } });
          this.setState({ searchCriteria: { date: data.date, phamacyIdNeighbor: data.pharmacyId } });
          this.setState({ hasChanges: true });
          this.suggestInput.focus();
        }}
        render={({ handleSubmit, form, hasValidationErrors, dirty, values }) => {
          return (
            <form onSubmit={handleSubmit}>
              <LeaveRouteDirtyWrapper blockChange={dirty} />
              <Container>
                <DivLine>
                  <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <Label style={{ marginRight: '10px', fontWeight: 'bold' }}>
                      {translate(TLCode.DUTYASSIGNMENT_Date)}
                    </Label>
                    <Tooltip content={translate(TLCode.GENERAL_PreviousDay)} hoverOpenDelay={700}>
                      <Button
                        icon={IconNames.CHEVRON_LEFT}
                        small={true}
                        style={{ height: '30px', marginRight: '5px' }}
                        onClick={() => {
                          const date2 = moment(this.state.date!).add(-1, 'd');
                          this.setState({ data: { date: date2.toDate() } });
                        }}
                      />
                    </Tooltip>
                    <DateInputFormField
                      name="date"
                      required={true}
                      //label={TLCode.DUTYASSIGNMENT_Date}
                      inline={true}
                      fill={true}
                    />
                    <Tooltip content={translate(TLCode.GENERAL_NextDay)} hoverOpenDelay={700}>
                      <Button
                        icon={IconNames.CHEVRON_RIGHT}
                        small={true}
                        style={{ height: '30px', marginLeft: '5px' }}
                        onClick={() => {
                          // const date = moment(this.state.searchDate).add(1, 'd');
                          // this.setState({ searchDate: date.toDate() });
                          // this.searchDuties({ date: date.format(), notAssigned: false, planningId: this.state.searchPlanning });
                          // this.dateSearchChange(date.toDate());
                          // onDateChange(date.format());
                          const date2 = moment(this.state.date!).add(1, 'd');
                          this.setState({ data: { date: date2.toDate() } });
                        }}
                      />
                    </Tooltip>
                    <Tooltip content={translate(TLCode.GENERAL_Today)} hoverOpenDelay={700}>
                      <Button
                        icon={IconNames.DOUBLE_CHEVRON_DOWN}
                        small={true}
                        style={{ height: '30px', marginLeft: '5px' }}
                        onClick={() => {
                          const date2 = moment(new Date());
                          this.setState({ data: { date: date2.toDate() } });
                        }}
                      />
                    </Tooltip>
                    <Tooltip content={translate(TLCode.GENERAL_NextYear)} hoverOpenDelay={700}>
                      <Button
                        icon={IconNames.DOUBLE_CHEVRON_RIGHT}
                        small={true}
                        style={{ height: '30px', marginLeft: '5px' }}
                        onClick={() => {
                          const date2 = moment(this.state.date!).add(1, 'y');
                          this.setState({ data: { date: date2.toDate() } });
                        }}
                        // text={translate(TLCode.GENERAL_NextYear)}
                      />
                    </Tooltip>
                  </div>
                  <DivColumn style={{ width: '300px' }}>
                    <PharmacyFormField2
                      getRef={(input) => {
                        this.suggestInput = input;
                      }}
                      pharmacyList={pharmacyList.filter(this.showPharmacy)}
                      required={true}
                    />
                  </DivColumn>
                  <DivColumn>
                    <SimpleTextFormContent label={TLCode.DUTYASSIGNMENT_Type}>
                      <RadioGroupFormField name={`type`} required={true}>
                        <RadioInput key={'DAY'} label={TLCode.DUTYASSIGNMENT_DAY} value="DAY" />
                        <RadioInput key={'DAY&NIGHT'} label={TLCode.DUTYASSIGNMENT_DAY_AND_NIGHT} value="DAY/NIGHT" />
                        <RadioInput key={'NIGHT'} label={TLCode.DUTYASSIGNMENT_NIGHT} value="NIGHT" />
                      </RadioGroupFormField>
                    </SimpleTextFormContent>
                    <ButtonsContainer>
                      <Button
                        text={translate(TLCode.GENERAL_Reset)}
                        icon={IconNames.ERASER}
                        intent={Intent.PRIMARY}
                        onClick={() => {
                          this.setState({ data: { date: null, pharmacyId: null, type: null } });
                          form.reset();
                        }}
                      />
                    </ButtonsContainer>
                  </DivColumn>
                  <DivColumn>
                    <ButtonsContainer>
                      <Button
                        type={'submit'}
                        text={translate(TLCode.DUTYASSIGNMENT_AddDuty)}
                        icon={IconNames.ADD}
                        intent={Intent.PRIMARY}
                        disabled={hasValidationErrors || !dirty}
                      />
                      <Button
                        text={translate(TLCode.DUTYASSIGNMENT_NotifySecretariat)}
                        icon={IconNames.SEND_TO}
                        intent={Intent.DANGER}
                        disabled={hasValidationErrors || !hasChanges}
                        onClick={() => {
                          DutyAssignmentStore!.sendLatestAdditions();
                          this.setState({ hasChanges: false });
                          this.props.cleanGeneratedDuties();
                          form.reset();
                        }}
                      />
                      <Button>
                        <Link to={`${Page.Duties}`}>
                          <TranslatedMessage id={TLCode.BackToList} />
                        </Link>
                      </Button>
                    </ButtonsContainer>
                  </DivColumn>
                </DivLine>
              </Container>
              <FormSpy subscription={{ values: true }}>
                {({ form }) => {
                  const dateValue = form.getFieldState(`date`)!.value;
                  const pharmacyId = form.getFieldState(`pharmacyId`)!.value;
                  const dateFinalValue = dateValue ? moment(dateValue).format() : null;
                  const type = form.getFieldState(`type`)!.value;
                  if (dateFinalValue !== this.state.date || pharmacyId !== this.state.pharmacyId) {
                    this.setState({ date: dateFinalValue, pharmacyId, type: type });
                    if (dateFinalValue != null) {
                      this.setState({ searchCriteria: { date: dateFinalValue, phamacyIdNeighbor: pharmacyId } });
                      getDutyAssignmentForSelection({
                        date: dateFinalValue,
                        phamacyIdNeighbor: pharmacyId,
                        type: type,
                      });
                    }
                  }
                  return null;
                }}
              </FormSpy>
            </form>
          );
        }}
      />
    );
  }
}

export default withTranslate(DutyAssignmentForm);

const Container = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  flex-basis: auto;
`;

const DivLine = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const DivColumn = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: 5px;
`;

const ButtonsContainer = styled.div`
  display: flex;
  align-content: center;
  justify-content: flex-end;
  button {
    margin-left: 5px;
  },
  `;
